<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
	.van-uploader__upload{
		width: 50px !important;
		height: 50px !important;
		background-color:#f2e2ca;
	}
	.van-uploader__upload-icon{
		color: #cec7b7;
		font-weight: bolder;
	}
	.text-div .van-field__control{
		padding: 0 !important;
	}
	.van-field--min-height .van-field__control{
		min-height: 40px !important;
	}
	.van-field__control::placeholder{
		text-align: center;
		color: #d5cfab;
	}
</style>
